import _                 from 'underscore';
import React, { FC }     from 'react';
import { Icon, Message } from 'semantic-ui-react';
import classNames        from 'classnames';
import { ClassValue }    from 'classnames/types';

import { SystemAccountingQueries }     from '../../../queries';
import { CorvalAccountLike, Uuid }     from '../../../types';
import { ItemFromQuery }               from '../from-query/ItemFromQuery';
import { InlineLoadingIndicatorLabel } from '../util/loading/InlineLoadingIndicatorLabel';

interface AccountUserProps {
	accountId: Uuid,
	loadingLabel?: string,
	className?: ClassValue,
	as?: any,
	
	[ additionalProps: string ]: any
}

const defaultProps: AccountUserProps = {
	as:           'span',
	accountId:    null,
	className:    null,
	loadingLabel: 'Finding user...',
}

const AccountUser: FC<AccountUserProps> = ( _props ) => {
	
	let { accountId, className, ...props } = _props;
	
	if( !accountId ) return null;
	
	return (
		
		<ItemFromQuery
			as={ props.as }
			className={ classNames( className ) }
			query={ SystemAccountingQueries.queries.GET_ACCOUNT( `
					id
					emailAddress
					firstName
					lastName
					systemRole
					createdUtc
					updatedUtc`
			) }
			queryOptions={ {
				variables: { id: accountId }
			} }
			queryResultObject={ ( data: any ) => {
				
				let member = data.accounts[ 0 ];
				
				return _.isUndefined( member ) ? { id: accountId } : member;
			} }
			loadingComponent={ () => (
				<InlineLoadingIndicatorLabel label={ props.loadingLabel }/>
			) }
			noItemComponent={ () => (
				<Icon.Group>
					<Icon size='small' color='red' name='dont'/>
					<Icon color='black' name='user'/>
				</Icon.Group>
			) }>
			
			{ ( item: CorvalAccountLike ) => _.isFunction( props.children ) ? props.children( item ) : props.children }
		
		</ItemFromQuery>
	);
};

AccountUser.defaultProps = defaultProps;

export { AccountUser }
